import React from 'react';
import { IconButton } from '@mui/material';

/**
 * Fullscreen toggle button component
 * @param {Object} props - Component props
 * @param {boolean} props.isFullscreen - Current fullscreen state
 * @param {Function} props.onToggle - Function to call when button is clicked
 * @param {Object} props.sx - Additional sx styles
 * @param {string} props.position - Button position ('top-right', 'top-left', 'bottom-right', 'bottom-left')
 * @param {number} props.zIndex - Z-index for the button
 * @param {boolean} props.visible - Whether to show the button
 */
const FullscreenButton = ({
    isFullscreen,
    onToggle,
    sx = {},
    position = 'top-right',
    zIndex = 10001,
    visible = true
}) => {
    if (!visible) return null;

      // Position styles based on position prop
  const getPositionStyles = () => {
    const baseStyles = {
      position: isFullscreen ? "fixed" : "absolute",
      zIndex: isFullscreen ? 2147483647 : zIndex, // Max z-index when in fullscreen
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      color: "white",
      width: 25,
      height: 25,
      p: 0.1,
      borderRadius: "20%",
      '&:hover': {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        transform: "scale(1.1)"
      },
      transition: "all 0.3s ease"
    };

        switch (position) {
            case 'top-left':
                return { ...baseStyles, top: 8, left: 8 };
            case 'bottom-right':
                return { ...baseStyles, bottom: 8, right: 8 };
            case 'bottom-left':
                return { ...baseStyles, bottom: 8, left: 8 };
            case 'top-right':
            default:
                return { ...baseStyles, top: 8, right: 8 };
        }
    };

    // Exit fullscreen icon
    const ExitFullscreenIcon = () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
        </svg>
    );

    // Enter fullscreen icon
    const EnterFullscreenIcon = () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
        </svg>
    );

    return (
        <IconButton
            onClick={onToggle}
            sx={{
                ...getPositionStyles(),
                ...sx
            }}
            aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
            title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
        >
            {isFullscreen ? <ExitFullscreenIcon /> : <EnterFullscreenIcon />}
        </IconButton>
    );
};

export default FullscreenButton; 